import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Courses from "../components/Home/Courses";
import Clipchart from "../components/Clipchart/Clipchart";
import Viewcourse from "../components/Course/Viewcourse";
import "../css/App.css";
import Homescreen from "../components/Home/Homescreen";
import Bookstore from "../components/Bookstore/Bookstore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "../components/Admin/Config/Config";
import Folder from "../components/Course/Folder";
import AudioCall from "../components/AudioCall/AudioCall";
import Purchase from "../components/Purchase/Purchase";
import Audio from "../components/AudioCall/Audio";
import Callui from "../components/AudioCall/Callui";
import Checkout from "../components/Bookstore/Checkout";
import Pdfview from "../components/Course/Pdfview";
import BookDetails from "../components/Bookstore/BookDetails";
import IncommingCall from "../components/AudioCall/IncommingCall";
import Ai from "../components/Ai/Ai";
import Toast from "../components/Toast/Toast";
import Viewclips from "../components/Clipchart/Viewclips";
import Viewbooks from "../components/Bookstore/Viewbooks";
import BookList from "../components/Bookstore/BookList";
import Terms from "../components/Home/Footercontent/Terms";
import Privacy from "../components/Home/Footercontent/Privacy";
import Refund from "../components/Home/Footercontent/Refund";
import Shipping from "../components/Home/Footercontent/Shipping";
import Profile from "../components/Profile/Profile";
// import Paymentfaild from "../components/Payment/Paymentfaild";
import About from "../components/Home/Footercontent/About";
import CoursePricing from "../components/Pricing/CoursePricing";
export default function Rooot() {
  const auth = getAuth(app);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();
  const [loginFlag, setLoginFlag] = useState(false);
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if(user){
      setIsLoggedIn(!!user);
      setLoginFlag(true);
      } else {
        setIsLoggedIn(false);
        setLoginFlag(true);
      }
    });
  }, [auth]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);



  return (
    <Routes>
      <Route
        path="/*"
        element={
          <div>
            <main className="flex-1 overflow-y-auto custom-scrollbar">
              <Routes>
              {loginFlag &&
                <>
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/refund" element={<Refund />} />
                  <Route path="/shipping" element={<Shipping />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/course-pricing" element={<CoursePricing />} />
                  {isLoggedIn ? (
                    <>
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/call" element={<AudioCall />} />
                      <Route path="/clipchart" element={<Clipchart />} />
                      <Route path="/view-course" element={<Viewcourse />} />
                      <Route path="/book" element={<Bookstore />} />
                      <Route path="/view-folder" element={<Folder />} />
                      <Route path="/Purchase" element={<Purchase />} />
                      <Route path="/bristu-talk" element={<Audio />} />
                      <Route path="/callui" element={<Callui />} />
                      <Route path="/checkout" element={<Checkout />} />
                      <Route path="/pdf" element={<Pdfview />} />
                      <Route path="/income" element={<IncommingCall />} />
                      <Route path="/ai" element={<Ai />} />
                      <Route path="/toast" element={<Toast />} />
                      <Route path="/book-details" element={<BookDetails />} />
                      <Route path="/viewbooks" element={<Viewbooks />} />
                      <Route path="/book-list" element={<BookList />} />
                      <Route path="/viewclip" element={<Viewclips />} />
                    </>
                  ) : null}

                  <Route
                    path="/"
                    element={isLoggedIn ? <Courses /> : <Homescreen />}
                  />
                  <Route path="*" element={<Navigate to="/" />} />
                </>
              }
              </Routes>
            </main>
          </div>
        }
      />
    </Routes>
  );
}